import React from "react";
import { Route, Routes } from "react-router-dom";
import PrintBatchTracking from "../pages/Inventory/batch_tracking/PrintBatchTracking";
import BatchTracking from "../pages/Inventory/BatchTracking";
import BranchDrugReconciliation from "../pages/Inventory/BranchDrugReconciliation";
import BranchDrugReorderLevel from "../pages/Inventory/BranchDrugReorderLevel";
import BranchInventory from "../pages/Inventory/branch/BranchInventory";
import ProcessInvoice from "../pages/Inventory/ProcessInvoice";
import EditInvoice from "../pages/Inventory/EditInvoice";
import NewStockInvoice from "../pages/Inventory/NewStockInvoice";
import SupplierInvoice from "../pages/Inventory/SupplierInvoice";
import RestoreBranchInventory from "../pages/Inventory/RestoreBranchInventory";
import ResetBranchStock from "../pages/Inventory/ResetBranchStock";
import BranchReconciliation from "../pages/Inventory/BranchReconciliation";
import RestockInventory from "../pages/Inventory/RestockInventory";
import BelowReorder from "../pages/Inventory/BelowReorder";
import InventoryStock from "../pages/Inventory/InventoryStock";
import ReorderLevel from "../pages/Inventory/ReorderLevel";
import CreateInterbranch from "../pages/Inventory/CreateInterbranch";
import InterbranchTransfers from "../pages/Inventory/InterbranchTransfers";
import NewDrugBatch from "../pages/Inventory/NewDrugBatch";
import SupplierInvoiceDetail from "../pages/Inventory/SupplierInvoice/SupplierInvoiceDetail";
import RoleBasedRoutes from "./RoleBasedRoutes";
import BranchExpiringInventory from "../pages/Inventory/branch/BranchExpiringInventory";
import PriceUpdates from "../pages/Inventory/PriceUpdates";
import CompanyInventory from "../pages/Administration/inventory/CompanyInventory";
import RequestedDrugsSummary from "../pages/Inventory/Requisition/RequestedDrugsSummary";
import CashierItemReturn from "../pages/POS/CashierItemReturn";
import Damages from "../pages/POS/Damages";
import InvoiceRoutes from "./InvoiceRoutes";
import NewRequisition from "../pages/POS/NewRequisition";
import StockRequisitionDetail from "../pages/POS/StockRequisitionDetail";
import StockRequisition from "../pages/POS/StockRequisition";
import ZeroStockDrugs from "../pages/Inventory/ZeroStockDrugs";
import InterbranchDetail from "../pages/Authorization/InterbranchDetail";
import AvailableStock from "../pages/Inventory/AvailableStock";
import AvailableBranchInventory from "../pages/Inventory/branch/AvailableBranchInventory";

const InventoryRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <RoleBasedRoutes allowedRoles={["dispenser", "branch_manager"]} />
        }
      >
        <Route path="/requisition" element={<StockRequisition />} />
        <Route path="/requisition/new" element={<NewRequisition />} />
        <Route
          path="/requisition/detail/:requisition_id"
          element={<StockRequisitionDetail />}
        />
        <Route path="/return-item" element={<CashierItemReturn />} />
      </Route>
      <Route path="/damages" element={<Damages />} />
      <Route path="/interbranch" element={<InterbranchTransfers />} />
      <Route
        path="/interbranch/view/:request_id"
        element={<InterbranchDetail />}
      />
      <Route path="/interbranch/create" element={<CreateInterbranch />} />
      <Route path="/reorder" element={<ReorderLevel />} />
      <Route path="/stock" element={<InventoryStock />} />
      <Route path="/stock/available" element={<AvailableStock />} />
      <Route path="/stock/available/:branch_id" element={<AvailableBranchInventory />} />
      <Route path="/reorder/level" element={<BelowReorder />} />
      <Route path="/zero-stock" element={<ZeroStockDrugs />} />

      <Route path="/branch/:branch_id" element={<BranchInventory />} />
      <Route
        path="/branch/expiring-drugs/:branch_id"
        element={<BranchExpiringInventory />}
      />
      <Route path="/price-updates" element={<PriceUpdates />} />
      <Route path="/price-list" element={<CompanyInventory />} />
      <Route
        path="/stock/reorder/:inventory_id"
        element={<BranchDrugReorderLevel />}
      />

      <Route path="/batch-tracking" element={<BatchTracking />} />
      <Route path="/batch-tracking/print" element={<PrintBatchTracking />} />
      <Route
        path="/invoice/*"
        element={
          <RoleBasedRoutes
            allowedRoles={["superadmin", "admin", "stores"]}
            component={InvoiceRoutes}
            fallback="/not-found"
          />
        }
      />
      {/* HIGHER LEVEL ROUTES */}
      <Route
        element={
          <RoleBasedRoutes
            allowedRoles={["superadmin", "admin"]}
            fallback="/not-found"
          />
        }
      >
        <Route
          path="/stock/reconcile/:inventory_id"
          element={<BranchDrugReconciliation />}
        />
        <Route path="/restock" element={<RestockInventory />} />
        <Route path="/reconciliation" element={<BranchReconciliation />} />
        <Route path="/reset" element={<ResetBranchStock />} />
        <Route path="/restore" element={<RestoreBranchInventory />} />
      </Route>
      <Route path="/batch-tracking/new" element={<NewDrugBatch />} />
      <Route path="/requisition/overview" element={<RequestedDrugsSummary />} />
    </Routes>
  );
};

export default InventoryRoutes;
